/** * @Author: liujiannan * @Date: 2020-09-21 10:50:16 * @Description 医院简介
*/
<template>
  <div class="hospital-introduce">
    <div>
      <img :src="require(`@assets/banner1.png`)" alt="" />
      <h2 class="hospital-introduce-title">
        {{ hospitalInfo.hospitalName }}
      </h2>

      <div class="hospital-introduce-tag">
        {{ hospitalInfo.levelName }}
      </div>
      <a :href="`tel://${hospitalInfo.tel}`" class="hospital-introduce-info">
        <van-icon name="phone-o" size="13px" />
        电话:{{ hospitalInfo.tel }}
        <span>拨打电话</span>
      </a>
      <a class="hospital-introduce-info">
        <van-icon name="location-o" size="13px" />
        地址:{{ hospitalInfo.address }}
      </a>
    </div>
    <div class="hospital-introduce-describe">
      <h2 class="hospital-introduce-title">医院简介</h2>
      <div v-html="hospitalInfo.intro">{{ hospitalInfo.intro }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hospitalInfo: {}
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_HOSPITAL_INFO).then(res => {
      this.hospitalInfo = res;
    });
  }
};
</script>

<style lang="less" scoped>
.hospital-introduce {
  font-size: 0.88rem;
  background: white;

  > div {
    padding: 0.75rem;
  }

  img {
    width: 100%;
    border: solid 1px #ddd;
    border-radius: 1px;
  }

  &-title {
    font-size: 1.06rem;
  }
  &-tag {
    display: inline-block;
    margin-bottom: 0.5rem;
    padding: 0.25rem;
    background-color: #f1f1f1;
    border-radius: 4px;
  }
  &-info {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    color: black;

    i {
      margin-right: 0.3rem;
    }

    span {
      margin-left: 0.3rem;
      padding: 0 0.5rem;
      color: #fff;
      font-size: 0.65rem;
      text-align: center;
      background-color: @primary-blue;
      border-radius: 1rem;
    }
  }

  &-describe {
    border-top: 1rem solid @primary-gray;

    div {
      color: gray;
    }
  }
}
</style>
